import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'accounting:commandCenter';
const listeners = new Set<() => void>();

export interface CommandCenterState {
  /** Empty means "all companies". */
  selectedCompanyIds: string[];
  from: string | null;
  to: string | null;
}

const DEFAULT: CommandCenterState = { selectedCompanyIds: [], from: null, to: null };

function readInitial(): CommandCenterState {
  if (typeof window === 'undefined') return DEFAULT;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) return { ...DEFAULT, ...(JSON.parse(raw) as Partial<CommandCenterState>) };
  } catch {
    /* ignore corrupt storage */
  }
  return DEFAULT;
}

let cache: CommandCenterState = readInitial();

function read(): CommandCenterState {
  return cache;
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function setCommandCenter(patch: Partial<CommandCenterState>): void {
  cache = { ...cache, ...patch };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  listeners.forEach((cb) => cb());
}

export function useCommandCenterStore(): CommandCenterState {
  return useSyncExternalStore(subscribe, read, () => DEFAULT);
}
